'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MyFeiseannaDirective = function () {
  function MyFeiseannaDirective($state, $scope) {
    _classCallCheck(this, MyFeiseannaDirective);

    this._ = { $state: $state, $scope: $scope };
    $scope.search = '';
  }

  _createClass(MyFeiseannaDirective, [{
    key: 'clearSearchFilter',
    value: function clearSearchFilter() {
      this._.$scope.search = '';
    }
  }]);

  return MyFeiseannaDirective;
}();

exports.default = angular.module('ifeis.dashboard-my-feiseanna', []).directive('fMyFeiseanna', function () {
  return {
    bindToController: true,
    controller: 'MyFeiseannaDirective',
    controllerAs: 'myFeis',
    replace: true,
    scope: {
      myFeis: '='
    },
    template: require('./tpl.html')
  };
}).controller('MyFeiseannaDirective', MyFeiseannaDirective);


//////////////////
// WEBPACK FOOTER
// ./routes/dashboard/my-feiseanna/index.js
// module id = 525
// module chunks = 0